import useDepartmentName from "./useDepartmentName";

const DepartmentName = ({ code }) => {
  const departmentName = useDepartmentName({ code });

  return <span>{departmentName ? departmentName?.label : "..."}</span>;
};

export default DepartmentName;
